import React from 'react';
import { Button } from '@/components/ui/button';
import { X, AlertCircle, CheckCircle2 } from 'lucide-react';

interface MessageToastProps {
  type: 'error' | 'success';
  message: string;
  onDismiss: () => void;
}

export const MessageToast: React.FC<MessageToastProps> = ({
  type,
  message,
  onDismiss,
}) => {
  const isError = type === 'error';
  const bgColor = isError ? 'bg-destructive/95 border-destructive' : 'bg-green-600/95 border-green-500';
  const Icon = isError ? AlertCircle : CheckCircle2;

  return (
    <div className="fixed top-4 right-4 z-[100] max-w-md animate-in slide-in-from-top-2 fade-in duration-300">
      <div className={`flex items-center gap-2 p-3 sm:p-4 ${bgColor} backdrop-blur-sm shadow-lg rounded-lg text-white text-sm`}>
        <Icon className="h-4 w-4 sm:h-5 sm:w-5 shrink-0" />
        <span className="flex-1 font-medium">{message}</span>
        <Button 
          variant="ghost" 
          size="icon"
          onClick={onDismiss} 
          className="h-7 w-7 sm:h-8 sm:w-8 hover:bg-white/20 shrink-0 text-white"
        >
          <X className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
        </Button>
      </div>
    </div>
  );
};

